// Vue
import { mixins } from "vue-class-component";
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Icon } from "../../icon/Icon";

// Mixins
import { EventBus } from "../../../../mixins/event_bus/EventBus";

@Component({
  name: "Tab",
  components: {
    Icon,
  },
  mixins: [template],
})
export class Tab extends mixins(EventBus) {
  public get themeMap() {
    const themeMap = {
      secondary: 1,
      default: 2,
      grey: 3,
      line: 4,
    };

    return themeMap[this.theme];
  }

  public isActive: boolean = false;

  @Prop()
  public name!: string;

  @Prop()
  public label!: string;

  @Prop({ default: false })
  public disabled!: boolean;

  @Prop({ default: false })
  public error!: boolean;

  @Prop({ default: true })
  public showHeader!: boolean;

  @Inject("tabsTheme")
  public theme!: string;

  @Prop({ default: true })
  public renderTab!: boolean;

  @Watch("name")
  public watchName(name) {
    this.dispatch("Tabs", "registerTabInfo", [this.name, this.label, this.disabled, this.error, this.showHeader]);
  }

  @Watch("label")
  public watchLabel(label) {
    this.dispatch("Tabs", "registerTabInfo", [this.name, this.label, this.disabled, this.error, this.showHeader]);
  }

  @Watch("disabled")
  public watchDisabled(disabled) {
    this.dispatch("Tabs", "updateTabDisabledStatus", [this.name, this.disabled]);
  }

  @Watch("error")
  public watchError(error) {
    this.dispatch("Tabs", "updateTabErrorStatus", [this.name, this.error]);
  }

  @Watch("showHeader")
  public watchShowHeader(showHeader) {
    this.dispatch("Tabs", "updateTabShowHeaderStatus", [this.name, this.showHeader]);
  }

  public created() {
    this.$on("activeChanged", this.handleActiveChanged);
    this.dispatch("Tabs", "registerTabInfo", [this.name, this.label, this.disabled, this.error, this.showHeader]);
  }

  public destroyed() {
    this.$off("activeChanged", this.handleActiveChanged);
    this.dispatch("Tabs", "deleteNameAndLabel", [this.name]);
  }

  private handleActiveChanged(activeTabNameOrTabs: any) {
    const old = this.isActive;

    if (activeTabNameOrTabs instanceof Array) {
      this.isActive = activeTabNameOrTabs.includes(this.name);
    } else {
      this.isActive = activeTabNameOrTabs == this.name;
    }

    if (!old && this.isActive) {
      this.$emit("active");
    }
  }

  private handleTabSelect(e) {
    if (!this.disabled) {
      this.dispatch("Tabs", "setTabAsActive", [this.name]);
    }
  }
}
